(function () {
  'use strict';

  function basisSpalte(abschnitt) {
    var zeilen = abschnitt.querySelectorAll('.ol-vgl__zeile');
    for (var i = 0; i < zeilen.length; i++) {
      var name = zeilen[i].querySelector('.ol-vgl__mtext');
      if (!name || !/access/i.test(name.textContent || '')) continue;
      var zellen = zeilen[i].querySelectorAll('.ol-vgl__zelle[data-spalte]');
      for (var k = 0; k < zellen.length; k++) {
        if (zellen[k].querySelector('.ol-vgl__nein')) {
          return zellen[k].getAttribute('data-spalte');
        }
      }
      return null;
    }
    return null;
  }

  function helferErgaenzen(abschnitt) {
    var liste = abschnitt.querySelector('.ol-vgl__helferliste');
    if (!liste) return;

    var meta = document.querySelector('meta[name="ol-vgl-basis"]');
    var satz = meta ? (meta.getAttribute('content') || '').trim() : '';
    if (!satz || satz.indexOf('translation missing') === 0) return;

    /* Baut der Abschnitt die Frage selbst wieder, steht ihr Satz
       bereits da - dann haelt sich das Skript heraus. Derselbe Satz
       ist das sicherste Erkennungszeichen, das es hier gibt. */
    var faelle = liste.querySelectorAll('.ol-vgl__helferfall');
    for (var i = 0; i < faelle.length; i++) {
      if ((faelle[i].textContent || '').trim() === satz) return;
    }

    var vorlage = liste.querySelector('li');
    if (!vorlage) return;

    var spalte = basisSpalte(abschnitt);
    if (!spalte) return;

    var karte = abschnitt.querySelector('.ol-vgl__karte[data-spalte="' + spalte + '"]');
    if (!karte) return;
    var kartenname = karte.querySelector('.ol-vgl__name');
    if (!kartenname) return;

    var zeile = vorlage.cloneNode(true);
    var knopf = zeile.querySelector('.ol-vgl__helferknopf');
    var fall = zeile.querySelector('.ol-vgl__helferfall');
    var zielname = zeile.querySelector('.ol-vgl__helferziel span');
    if (!knopf || !fall || !zielname) return;

    knopf.setAttribute('data-ziel', spalte);
    knopf.setAttribute('aria-pressed', 'false');
    knopf.classList.remove('ist-aktiv');
    fall.textContent = satz;
    /* "Microsoft " faellt weg wie bei den anderen Fragen auch. */
    zielname.textContent = (kartenname.textContent || '').trim().replace(/^Microsoft\s+/i, '');

    function spiegeln() {
      var an = karte.classList.contains('ist-gewaehlt');
      if (an) { knopf.classList.add('ist-aktiv'); } else { knopf.classList.remove('ist-aktiv'); }
      knopf.setAttribute('aria-pressed', an ? 'true' : 'false');
    }

    /* Der Abschnitt hat seine eigenen Knoepfe beim Laden eingesammelt -
       dieser hier war da noch nicht dabei. Deshalb klickt er einfach
       die Karte an; alles Weitere macht der Abschnitt wie gehabt. */
    knopf.addEventListener('click', function () {
      var vorher = karte.classList.contains('ist-gewaehlt');
      karte.click();
      spiegeln();
      if (vorher || !karte.scrollIntoView) return;
      var eng = window.matchMedia && window.matchMedia('(max-width: 989px)').matches;
      if (!eng) return;
      var sanft = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      try {
        karte.scrollIntoView({ behavior: sanft ? 'auto' : 'smooth', block: 'center' });
      } catch (fehler) {
        karte.scrollIntoView();
      }
    });

    /* Wird stattdessen eine Karte oder eine andere Frage angeklickt,
       zieht dieser Knopf nach. Der Abschnitt kennt ihn nicht. */
    abschnitt.addEventListener('click', function () {
      window.setTimeout(spiegeln, 0);
    });

    liste.insertBefore(zeile, liste.firstElementChild);
    spiegeln();
  }

  function los() {
    var abschnitte = document.querySelectorAll('.ol-vgl');
    Array.prototype.forEach.call(abschnitte, helferErgaenzen);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', los);
  } else {
    los();
  }
})();

